export function puedeVerPanelAdmin(session) {
  const applications = Array.isArray(session?.applications)
    ? session.applications
    : [];

  return applications.some((entry) => {
    const codes = [
      entry?.application?.code,
      entry?.application?.applicationCode,
      entry?.applicationCode,
      entry?.code,
    ].filter(Boolean);

    return codes.some(
      (code) => String(code).trim().toUpperCase() === 'SUITE_HOME'
    );
  });
}

export function puedeVerLogistica(session) {
  const applications = Array.isArray(session?.applications)
    ? session.applications
    : [];

  return applications.some((entry) => {
    const codes = [
      entry?.application?.code,
      entry?.application?.applicationCode,
      entry?.applicationCode,
      entry?.code,
    ].filter(Boolean);

    return codes.some(
      (code) => String(code).trim().toUpperCase() === 'LOGISTICS'
    );
  });
}
